const stateTypes = {
  UNPAID: 0,
  PAID: 1,
  CARD_TOKENS_ASSIGNED: 2,
  ACTIVATION_CODES_GENERATED: 3,
  CARDS_LOADED: 4,
  SENT: 5,
  READY_FOR_PICKUP: 7,
  PICKED_UP: 8,
  COMPLETED: 98,
  CANCELLED: 99
}

const orderTypes = {
  SHIPPING: 1,
  SELF_PICKUP_AT_SHOPPING_CENTER: 2,
  CLICK_AND_COLLECT: 3
}

export {
  stateTypes,
  orderTypes
}
